export const MAX_FILE_UPLOAD_SIZE_IN_BYTES = 50 * 1024 * 1024; // 50MB
